import React from 'react';
import { Box, Crown, Diamond } from 'lucide-react';
import './PlanIcon.css';

const ICONS = { starter: Box, business: Crown, enterprise: Diamond };

/** A plan's picture from Subscription Control, or its built-in icon. */
export default function PlanIcon({ plan, size = 48 }) {
  const Icon = ICONS[plan.tier] || Box;
  return (
    <span className={`tcx-plan-icon ${plan.tier}`} style={{ width: size, height: size }}>
      {plan.imageUrl ? <img src={plan.imageUrl} alt="" /> : <Icon size={Math.round(size * 0.5)} />}
    </span>
  );
}
